import { ChartRef } from '../types/refs';
import { ChartAxis } from '../types/axis';
import { AxisOptions } from '../types/series-options';


export function xAxis<TRow extends object>(ref: ChartRef<TRow>,
                                           options: AxisOptions): ChartAxis {
  const xAxis = {
    ...options,
    name: 'x'
  }
  ref.createAxis(xAxis);
  return xAxis;
}
